export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11200.9ad7a397.jpg";